import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { QnaPageComponent } from './qna-page.component';
import { QnaStartComponent } from './start/start.component';
import { QnaQuestionsComponent } from './questions/questions.component';
import { QnaAdviceComponent } from './advice/advice.component';

import { QnaAdviceIndexComponent } from './index/advice-index.component';
import { QnaSnippetIndexComponent } from './index/snippet-index.component';

import { QnaCookiesPageComponent } from './cookies/cookies.component';
import { QnaContactPageComponent } from './contact/contact.component';
import { QnaPrivacyPageComponent } from './privacy/privacy.component';
import { QnaAccessibilityPageComponent } from './accessibility/accessibility.component';
import { QnaLanguagesComponent } from './languages/languages.component';
import { QnaMoneyManagerPageComponent } from './tools/money-manager/money-manager.component';
import { QnaSafetyPageComponent } from './safety/safety.component';

const routes: Routes = [
  {
    path: '',
    component: QnaPageComponent,

    children:  [
      { path: 'cookies', component: QnaCookiesPageComponent },
      { path: 'contact', component: QnaContactPageComponent },
      { path: 'privacy', component: QnaPrivacyPageComponent },
      { path: 'accessibility', component: QnaAccessibilityPageComponent },
      { path: 'safety', component: QnaSafetyPageComponent },
      { path: 'languages', component: QnaLanguagesComponent },

      { path: 'start', component: QnaStartComponent },

      // questions
      { path: 'questions/:questionId/:path', component: QnaQuestionsComponent },
      { path: 'questions/:questionId', component: QnaQuestionsComponent },
      { path: 'questions', component: QnaQuestionsComponent},

      // advice
      { path: 'advice/:result', component: QnaAdviceComponent },

      // index
      { path: 'advice', component: QnaAdviceIndexComponent },
      { path: 'snippets', component: QnaSnippetIndexComponent },

      // tools
      { path: 'tools/money-manager', component: QnaMoneyManagerPageComponent },
      { path: 'tools', redirectTo: 'tools/money-manager' },

      { path: '**', pathMatch: 'full', redirectTo: 'start'},
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class QnaRoutingModule { }
